<template>
    <tbody>
        <tr v-if="showGroupsRow(car.shipping_group_id)" class="shipping">
            <td colspan="37" style="background-color: white; font-size: medium">
                <p :class="{'fixed' : isNotMobile}">
                    <i class="fas fa-ship"></i>
                    #{{ car.shipping_group.id }}
                    <span @click="lockUnlockShippingGroup(null)" v-if="car.shipping_group.locked" class="icon has-text-danger">
                         <i class="fas fa-lock"></i>
                    </span>
                    <span @click="lockUnlockShippingGroup(1)" v-else class="icon has-text-success">
                        <i class="fas fa-lock-open"></i>
                    </span>
                    {{ car.shipping_group.name }}
                    ({{ getShippingGroupType(car.shipping_group.type) }})
                    ETD: <span class="has-text-primary">{{ car.estimated_departure }}</span>
                    ETA: <span class="has-text-primary">{{ car.estimated_arrival }}</span>
                    VESSEL: <span class="has-text-primary">{{ car.vessel }}</span>
                    B/l#: <span class="has-text-primary">{{ car.bill_of_landing_number }}</span>
                    <label class="checkbox">
                        <input type="checkbox" v-model="isChecked">
                    </label>
                </p>
            </td>
        </tr>
        <tr :class="isStriped">
            <td data-label="Photos:" class="headcol headcol-1 ss_position">
                <div class="level">
                    <figure class="image  is-48x48" style="float: left;">
                        <img :src="$appUrl+'/storage/photos/'+ car.id +'/2.jpg'" @error="imgUrlAlt($event, car.id, $appUrl)"/>
                    </figure>
                </div>
            </td>
            <td data-label="Lot:" class="headcol headcol-2 ss_position">
                <router-link :to="'/car/' + car.id" class="button is-small" target="_blank">
                    <span class="icon is-small" style="margin-right: 5px;"><i class="fas fa-search-plus"></i></span>
                    {{ car.bid }}
                </router-link>
            </td>
            <td data-label="Chassis:" class="headcol headcol-3 ss_position" style="min-width: 150px;">
                {{ car.model_type_en }}
            </td>
            <td v-if="!isSupplier" data-label="Client:" class="main-col nowrap" ><span class="link" @click="goToUserPage(car.user.id)">{{ car.user.name }}</span></td>
            <td v-if="!isSupplier" data-label="Manager:">{{ car.manager.name }}</td>
            <td v-if="!isSupplier" data-label="Buy:">
                <buy-column v-if="isAdmin" :car="car"></buy-column>
                <button class="button is-small date-select" :class="{'bold': isFilled(car.purchase_date) }"  v-else>{{  formatDate(car.purchase_date) }}</button>
            </td>
            <td data-label="S.Group:">
                <span v-if="car.shipping_group_id > 0">#{{ car.shipping_group.id }}</span>
                <span v-else>No group!</span>
            </td>
            <td data-label="Auction:" style="min-width: 150px;">
                <auction-name-column v-if="isAdmin" :car="car"></auction-name-column>
                <span v-else>{{ car.auction_name }}</span>
            </td>
            <td v-if="!isSupplier" data-label="Result:">
                <strong>{{ car.price * 1000 | formatNumber }}</strong>
            </td>
            <td v-if="!isSupplier" data-label="Invoice#:">
                <proforma-invoice-column :car="car"></proforma-invoice-column>
            </td>
            <td v-if="isAdmin" data-label="Action (ZOHO):">
                <action-column :car="car" :invoice="car.proforma_invoice"></action-column>
            </td>
            <td data-label="Remarks:">
                <remarks-column :car="car"></remarks-column>
            </td>
            <td v-if="!isSupplier" data-label="Balance:">
                <balance-column :car="car"></balance-column>
            </td>
            <td data-label="Inland:">
                <inland-company-column :car="car"></inland-company-column>
            </td>
            <td data-label="YAD:">
                <yard-arrival-date-column v-if="isAdmin || isSupplier" :car="car"></yard-arrival-date-column>
                <button class="button is-small date-select" :class="{'bold': isFilled(car.yard_arrival_date) }" v-else>{{  formatDate(car.yard_arrival_date) }}</button>
            </td>
            <td data-label="Yard:">
                <yard-column :car="car"></yard-column>
            </td>
            <td data-label="PICS:">
                <yard-pics-column v-if="isAdmin || isSupplier" :car="car"></yard-pics-column>
                <button class="button is-small date-select" :class="{'bold': isFilled(car.yard_pics) }" v-else>{{  formatDate(car.yard_pics)}}</button>
            </td>
            <td data-label="POL:">
                <port-of-loading-column :car="car"></port-of-loading-column>
            </td>
            <td data-label="POA:">
                <port-of-arrival-column :car="car"></port-of-arrival-column>
            </td>
            <td data-label="Line:">
                <shipping-line-column v-if="isAdmin || isSupplier" :car="car"></shipping-line-column>
                <button class="button is-small tooltip" :class="{'bold': isFilled(car.shipping_line) }" :data-tooltip="car.shipping_line ? car.shipping_line : '---'" v-else><span class="text-eclipse">{{ car.shipping_line ? car.shipping_line : '---' }}</span></button>
            </td>
            <td data-label="Vessel:">
                <vessel-column v-if="isAdmin || isSupplier" :car="car"></vessel-column>
                <button class="button is-small date-select tooltip" :class="{'bold': isFilled(car.vessel) }" :data-tooltip="car.vessel ? car.vessel : '---'" v-else><span class="text-eclipse">{{ car.vessel ? car.vessel : '---' }}</span></button>
            </td>
            <td v-if="!isSupplier" data-label="Docks:">
                <docs-recived-column :car="car"></docs-recived-column>
            </td>
            <td data-label="EC:">
                <export-certificate-column v-if="isAdmin || isSupplier" :car="car"></export-certificate-column>
                <button class="button is-small date-select" :class="{'bold': isFilled(car.export_certificate) }" v-else>{{  formatDate(car.export_certificate) }}</button>
            </td>
            <td data-label="ED:" v-if="isAdmin || isSupplier">
                <export-declaration-column :car="car"></export-declaration-column>
            </td>
            <td data-label="Ins.:" v-if="isAdmin">
                <inspection-column :car="car"></inspection-column>
            </td>
            <td data-label="ETD:">
                <estimated-departure-column v-if="isAdmin || isSupplier" :car="car"></estimated-departure-column>
                <button class="button is-small date-select" :class="{'bold': isFilled(car.estimated_departure) }" v-else>{{  formatDate(car.estimated_departure) }}</button>
            </td>
            <td data-label="ETA:">
                <estimated-arrival-column v-if="isAdmin || isSupplier" :car="car"></estimated-arrival-column>
                <button class="button is-small date-select" :class="{'bold': isFilled(car.estimated_arrival) }" v-else>{{  formatDate(car.estimated_arrival) }}</button>
            </td>
            <td data-label="B/L:">
                <bill-of-landing-column v-if="isAdmin || isSupplier" :car="car"></bill-of-landing-column>
                <button class="button is-small date-select" :class="{'bold': isFilled(car.bill_of_landing) }" v-else>{{ formatDate(car.bill_of_landing) }}</button>
            </td>
            <td data-label="Post:">
                <docs-send-column :car="car"></docs-send-column>
            </td>
            <td v-if="!isSupplier" data-label="Insurance:">
                <insurance-column :car="car"></insurance-column>
            </td>
        </tr>
    </tbody>
</template>

<script>
    import InlandCompanyColumn from './Columns/InlandCompanyColumn'
    import YardArrivalDateColumn from './Columns/YardArrivalDateColumn'
    import YardPicsColumn from './Columns/YardPicsColumn'
    import YardColumn from './Columns/YardColumn'
    import BuyColumn from './Columns/BuyColumn'
    import PortOfLoadingColumn from './Columns/PortOfLoadingColumn'
    import PortOfArrivalColumn from './Columns/PortOfArrivalColumn'
    import ShippingLineColumn from './Columns/ShippingLineColumn'
    import VesselColumn from './Columns/VesselColumn'
    import DocsRecivedColumn from './Columns/DocsRecivedColumn'
    import ExportCertificateColumn from './Columns/ExportCertificateColumn'
    import EstimatedDepartureColumn from './Columns/EstimatedDepartureColumn'
    import EstimatedArrivalColumn from './Columns/EstimatedArrivalColumn'
    import BillOfLandingColumn from './Columns/BillOfLandingColumn'
    import DocsSendColumn from './Columns/DocsSendColumn'
    import InspectionColumn from './Columns/InspectionColumn'
    import ExportDeclarationColumn from './Columns/ExportDeclarationColumn'
    import InsuranceColumn from './Columns/InsuranceColumn'
    import ChassisColumn from './Columns/ChassisColumn'
    import RemarksColumn from './Columns/RemarksColumn'
    import ProformaInvoiceColumn from './Columns/ProformaInvoiceColumn'
    import AuctionNameColumn from './Columns/AuctionNameColumn'
    import BalanceColumn from './Columns/BalanceColumn'
    import InvoiceDownloadColumn from './Columns/InvoiceDownloadColumn'
    import moment from 'moment'
    import apiCars from './../../api/apiCars'
    import ActionColumn from "./Columns/ActionColumn";
    export default {
        props:['car', 'i'],
        components: {
            ActionColumn,
            YardArrivalDateColumn,
            YardPicsColumn,
            BuyColumn,
            PortOfLoadingColumn,
            PortOfArrivalColumn,
            ShippingLineColumn,
            VesselColumn,
            DocsRecivedColumn,
            ExportCertificateColumn,
            EstimatedDepartureColumn,
            EstimatedArrivalColumn,
            BillOfLandingColumn,
            DocsSendColumn,
            InlandCompanyColumn,
            YardColumn,
            InspectionColumn,
            ExportDeclarationColumn,
            InsuranceColumn,
            ChassisColumn,
            RemarksColumn,
            ProformaInvoiceColumn,
            AuctionNameColumn,
            BalanceColumn,
            InvoiceDownloadColumn
        },
        data () {
            return {
                windowWidth: null,
                index: null,
                images: [],
                rowClass: '',
                carData: {
                    id: this.car.id,
                    query: {
                        shipping_group_id: this.car.shipping_group_id
                    }
                },
                statusLabels: [
                    {
                        tagClass: 'tag is-danger',
                        label: 'Canceled'
                    },
                    {
                        tagClass: 'tag is-link',
                        label: 'Active'
                    },
                    {
                        tagClass: 'tag is-success',
                        label: 'Win'
                    },
                    {
                        tagClass: 'tag is-warning',
                        label: 'Lose'
                    },
                    {
                        tagClass: 'tag is-warning',
                        label: 'Lose to other'
                    },
                    {
                        tagClass: 'tag is-warning',
                        label: 'Unsold'
                    },
                    {
                        tagClass: 'tag is-info',
                        label: 'Negotiations'
                    },
                ]
            }
        },
        methods: {
            lockUnlockShippingGroup(value) {
                if (!this.isAdmin) {
                    return
                }
                let data = {
                    id: this.car.shipping_group.id,
                    locked: value
                }
                this.$store.dispatch('updateShippingGroupById', data)
            },
            selectCar(value){
                if (this.$store.getters.getShippingGroupCarsById(value.id).length > 0) {
                    this.$store.dispatch('removeCarFromShippingGroup', value.id)
                    this.$store.dispatch('removeFullCarFromShippingGroup', value)
                } else {
                    this.$store.dispatch('updateShippingGroupCars', value.id)
                    this.$store.dispatch('updateShippingGroupFullCars', value)
                }
            },
            getShippingGroupType(type) {
                return type < 2 ? 'RoRo' : 'Container'
            },
            goToUserPage(id){
                this.$router.push({ name: 'EditUser', params: { id: id } });
            },
            showGroupsRow(group){
                if (this.$store.getters.getCarsOrderColumn === 'shipping_group_id'){
                    if (group !== null) {
                        if (this.i === 0){
                            return true
                        }
                        return this.$store.getters.getCars[this.i - 1].shipping_group_id !== group
                    }
                }
            },
            updateGroup(){
                apiCars
                    .updateCarRequest(this.carData)
                    .then((response) => {

                    })
                    .catch(error => console.log(error))
            },
            isFilled(value) {
                if (value !== null){
                    return  true;
                }
            },
            formatDate(date) {

                if(date){
                    return moment(date).format('M/D')
                }else{
                    return '---'
                }
            },
            imgUrlAlt(event, car_id, appurl){
                if(event.target.src.indexOf('1.jpg') > -1) {
                    event.target.src = '/static/images/hero-4.jpeg'
                }else{
                    event.target.src = appurl+'/storage/photos/'+ car_id +'/1.jpg';
                }
            }
        },
        computed: {
            isUserSinglePage(){
                return location.pathname.split('/')[1] !== 'users'
            },
            shippingGroups() {
                return this.$store.getters.getShippingGroups
            },
            checkedCars: {
                get: function () {
                    return  this.$store.getters.getShippingGroupCars
                },
                set: function (value) {

                }
            },
            isStriped() {
                if (this.i % 2 === 0) {
                    return 'white'
                } else {
                    return 'gray'
                }
            },
            isNotMobile() {
                return  this.windowWidth > 450;
            },
            isAdmin() {
                if (this.$store.getters.getUserRole === 'Admin') {
                    return true
                }
            },
            isSupplier() {
                if (this.$store.getters.getUserRole === 'Supplier') {
                    return true
                }
            },
            isChecked: {
                set(value){
                    if(value){
                        if(this.$store.getters.getGroupIds.indexOf(this.car.shipping_group_id) < 0){
                            this.$store.dispatch('setShippingGroupIds', this.car.shipping_group_id)
                        }
                    }else{
                        this.$store.dispatch('removeShippingGroupId', this.car.shipping_group_id)
                    }
                }
            }
        },
        mounted() {
            for (let i = 1; i <= this.car.photos; i++) {
                this.images.push('https://unetworld.com/storage/photos/'+ this.car.id +'/'+ i +'.jpg')
            }
            this.$nextTick(() => {
                window.addEventListener('resize', () => {
                    this.windowWidth = window.innerWidth
                });
            })
            this.$store.dispatch('removeAllShippingGroupIds');
        }
    }
</script>

<style scoped>
    .white {
        background-color: white;
    }
    .gray {
        background-color: whitesmoke;
    }
    tbody{
        overflow-x: scroll;
        max-height: 500px;
    }
    td {
        font-size: 10px;
        font-weight: bold;
        /*background-color: whitesmoke;*/
    }
    .is-responsive-table td {
        font-size: 10px;
    }
    .image {
        max-height: 32px;
        height: 32px;
        padding-left: 2px;
    }
    .is-automatic {
        background-color: rgba(0, 255, 255, 0.25);
    }
    .is-real {
        background-color: rgba(255, 255, 0, 0.27);
    }
    .is-win {

    }
    .is-canceled {

    }
    .nowrap {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .is-responsive-table table {
        width: 100%;
    }
    .is-responsive-table th {
        font-size: small;
    }
    .long {
        min-width: 75px;
    }
    .link {
        border-bottom: 1px solid blue;
        cursor: pointer;
    }
    .headcol {
        position: absolute;
        z-index: 1;
        border-style: solid;
        border-width: 1px;
        height: 42px;
    }
    .headcol-1 {
        width: 60px;
    }
    .headcol-2 {
        margin-left: 60px;
        width: 100px;
    }
    .headcol-3 {
        margin-left: 150px;
        width: 75px;
    }
    .headcol-4 {
        margin-left: 300px;
    }
    .main-col {
        padding-left: 320px!important;
    }
    .shipping {
        width: 100%;
        height: 40px;
        border-style: solid;
        border-width: 1px;
        border-color: whitesmoke;
    }
    .text-eclipse {
        max-width: 100px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .fixed {
        position: absolute;
    }
    .main-col{
        padding-left: 0 !important;
    }
    .main-head{
        padding-left: 0px!important;
    }

</style>



// WEBPACK FOOTER //
// src/components/Cars/CarTableRow.vue